import React from 'react';
import Bounce from "react-reveal/Bounce";
const HomeMapMarker = () => (
    <Bounce top>
        <div className="map-marker">
            <div className="bubble">Hello from Bucharest!</div>
        </div>
    </Bounce>
);

export default HomeMapMarker;


// WEBPACK FOOTER //
// ./src/components/home/Map/marker.js